import React, { useEffect } from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { NavCloseBtn } from 'public/assets';
import theme from '@styles/theme';
import Portal from '@components/commons/portal/Portal';

interface IInfoPopupContainer {
  children: JSX.Element[] | JSX.Element;
  customCSS?: SerializedStyles;
  title?: string;
  onClose?: () => void;
}

const InfoPopupContainer = ({
  title,
  customCSS,
  onClose,
  children,
}: IInfoPopupContainer) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <Portal>
      <div css={backDrop} />
      <div css={[container, customCSS]}>
        <div className={`popup-wrapper ${!onClose && 'center'}`}>
          {onClose && (
            <button className="close-button" onClick={onClose}>
              <NavCloseBtn width={24} height={24} fill={theme.colors.gray800} />
            </button>
          )}
          {title && <h1 className="title">{title}</h1>}
          {children}
        </div>
      </div>
    </Portal>
  );
};

const backDrop = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 100%;
  background: ${theme.colors.gray900};
  opacity: 0.6;
  overflow: hidden;
  z-index: 20;
`;

const container = css`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 19.5rem;
  transform: translate(-50%, -50%);
  padding: 1.5em 1.25em 1.5em;
  background: ${theme.colors.white};
  border-radius: 0.75em;
  max-width: 20.9375em;
  z-index: 29;

  .popup-wrapper {
    position: relative;
    margin: auto;

    .title {
      font: ${theme.font.title1};
      color: ${theme.colors.gray900};
    }

    .title.center {
      text-align: center;
    }

    .close-button {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 0;
      right: 0;
      background: none;
      cursor: pointer;
    }
  }

  .popup-wrapper.center {
    text-align: center;
  }

  @media (max-width: ${theme.devices.mobile}) {
    width: 100%;
  }
`;

export default InfoPopupContainer;
